import React from "react";
import "./Appraisalthree.css";
import { Link } from "react-router-dom";

/**
 * How It Works – Emerald Appraisal Services (four-card grid)
 * Left-to-right, top-to-bottom: the key stages of our engagement.
 */
export default function Appraisalthree({
  items,
  onExplore = () => {},
}) {
  // Default content (replace or pass via `items` prop)
  const data =
    items ??
    [
      {
        title: "Scope & Fit Check",
        img: "./howone.webp",
        alt: "Client and appraiser reviewing a project brief at a desk",
        text:
          "We confirm your purpose—purchase, refinance, estate, divorce, or assessment review—along with the effective date. You'll receive a straightforward quote, timing, and a short checklist of what to have ready.",
      },
      {
        title: "Property Walkthrough",
        img: "./howtwo.jpeg",
        alt: "Appraiser touring a home interior and taking notes",
        text:
          "A focused visit to verify features, materials, and overall condition. Photos and measurements are captured as needed. The appointment is efficient, respectful, and minimally disruptive.",
      },
      {
        title: "Evidence & Analysis",
        img: "./howthree.webp",
        alt: "Market data and charts displayed on a laptop",
        text:
          "We evaluate recent comparable sales, neighborhood movement, and property-specific factors like site, layout, and quality. Adjustments are explained so the value logic is easy to follow.",
      },
      {
        title: "Delivery & Support",
        img: "./howfour.jpeg",
        alt: "Printed appraisal report on a table with glasses and pen",
        text:
          "You receive a clear, lender-ready PDF within the agreed window. Have stakeholders who need context? We're available to help interpret findings and answer follow-up questions.",
      },
    ];

  return (
    <section className="Appraisalthree" aria-labelledby="ap3-title">
      <div className="Appraisalthree__container">
        {/* Heading + intro */}
        <header className="Appraisalthree__header">
          <h2 id="ap3-title" className="Appraisalthree__title">
            From Request to Report
          </h2>
          <p className="Appraisalthree__lead">
            Four simple stages from hello to hand-off—designed for clarity, pace, and a
            valuation you can put to work.
          </p>
        </header>

        {/* Grid */}
        <div className="Appraisalthree__grid" role="list">
          {data.map((card, i) => (
            <article className="Appraisalthree__card" role="listitem" key={i}>
              <div className="Appraisalthree__media">
                <img
                  src={card.img}
                  alt={card.alt}
                  width="520"
                  height="340"
                  loading="lazy"
                  decoding="async"
                />
                <div className="Appraisalthree__image-overlay"></div>
              </div>
              <h3 className="Appraisalthree__cardTitle">{card.title}</h3>
              <p className="Appraisalthree__text">{card.text}</p>
            </article>
          ))}
        </div>

        {/* Helper line */}
        <p className="Appraisalthree__hint">
          Unique circumstances? We can accommodate retrospective effective dates, tenant-occupied
          access, and expedited timelines—just ask.
        </p>

        {/* CTA */}
        <div className="Appraisalthree__ctaWrap">
     <Link to="/pricing" className="Appraisalthree__cta" aria-label="See the appraisal process">
  See the Process
  <svg
    className="Appraisalthree__cta-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
      fill="currentColor"
    />
  </svg>
</Link>
        </div>
      </div>
    </section>
  );
}